// extracted by mini-css-extract-plugin
export default {"companyShortItem":"CompanyShort_companyShortItem__mykY+","companyShortLink":"CompanyShort_companyShortLink__MdSTy","companyShortEditLink":"CompanyShort_companyShortEditLink__BFtYW"};